export default __webpack_public_path__ + "static/media/patent04-2.68096bb2.png";